var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFolder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_34_2504)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.15357 4.66242L7.39118 2.66177H6.19394L4.38232 1.11796C4.30356 1.0392 4.19329 1.00769 4.08299 1.00769H1.10564C0.837823 1.00769 0.633057 1.21249 0.633057 1.48027V4.66242H3.15357Z",
    fill: "#6AA287"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.078 4.6624H14.3697V3.13432C14.3697 2.86651 14.1649 2.66174 13.8972 2.66174H12.1328L13.078 4.6624Z",
    fill: "#6AA287"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5501 1.22817C11.4241 0.960351 11.0933 0.834344 10.8097 0.976121L2.80713 4.75689H13.2042L11.5501 1.22817Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M14.874 4.7254C14.7795 4.63087 14.6535 4.58362 14.5274 4.58362H14.3699H13.0781H3.15362H0.63311H0.475593C0.349555 4.58362 0.223547 4.63087 0.129019 4.7254C0.0344906 4.81992 -0.0127585 4.94593 0.00298115 5.07197L0.475562 13.6417C0.491302 13.8937 0.696098 14.0828 0.948144 14.0828H14.0548C14.3068 14.0828 14.5116 13.8938 14.5274 13.6417L15 5.07197C15 4.94593 14.9527 4.81989 14.874 4.7254Z",
    fill: "#6AA287"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_34_2504"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.8ca658edaa27083aec0cd5fecdd1e39c.svg";
export { ForwardRef as ReactComponent };